var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn labor-screening personPage withTabs" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "9" } },
            [
              _c(
                "b-tabs",
                {
                  staticClass: "labor-screening__tabs",
                  model: {
                    value: _vm.tabIndex,
                    callback: function($$v) {
                      _vm.tabIndex = $$v
                    },
                    expression: "tabIndex"
                  }
                },
                [
                  _c(
                    "b-tab",
                    {
                      staticClass: "introTab",
                      attrs: {
                        title: "Introduction",
                        disabled: _vm.disabledIntroTab
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "labor-screening__header labor-screening__header--center marginB-24"
                              },
                              [
                                _vm._v(
                                  "Louisiana Indicator Tool for Child & Youth Labor Trafficking"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "labor-screening__description" },
                              [
                                _vm._v(
                                  "\n                                The purpose of this tool is to provide indicators to assist in the identification of children and youth who may be victims of labor trafficking.\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "labor-screening__description" },
                              [
                                _c("b", [
                                  _vm._v(
                                    "\n                                    Instructions:\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                                    LA R.S. 14:46.2 states “it shall be unlawful for any person to knowingly recruit, harbor, transport, provide, solicit, receive, isolate, entice, obtain, or maintain the use of another person through fraud, force, or coercion to provide services or labor.” The screening uses indicators that meet the state of Louisiana’s definition of labor trafficking. The result of a completed screening identifies next steps for further monitoring, assessment, and/or reporting. This tool is to be used as a narrative assessment, NOT a questionnaire. The indicators outlined in the tool should not be asked directly to the child or youth. To determine if a child or youth may be a victim of labor trafficking, please check the boxes for any indicators that you note and follow the actions for reporting and referrals in the "
                                  ),
                                  _c("b", [_vm._v("Conclusion")]),
                                  _vm._v(
                                    " tab.\n                                "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "labor-screening__description" },
                              [
                                _c("span", [
                                  _vm._v(
                                    'The screening results categories are “not enough information," “concern,” and “indicated.” The tool does not include a result of “confirmed” trafficking; a determination that a child or youth is a confirmed victim of human trafficking requires an assessment and validation from a qualified professional. A screening result of “not enough information” does not necessarily mean that the child or youth has not experienced labor trafficking. If there is an indication that the child or youth is currently, was ever, or is in the process of being forced to perform labor or services, you should flag the case for “concern” and follow the actions for additional assessment.\n                                    '
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "labor-screening__description--italic"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        For the complete instructions, please refer to the\n                                        "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href:
                                              "https://lighthouse-pdf-images.s3.us-west-2.amazonaws.com/LT+Identification+Tool+Supplementary+Guide+FINAL.pdf"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            Supplementary User Guide\n                                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        ".\n                                    "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "labor-screening__description" },
                              [
                                _vm._v(
                                  "For questions regarding this tool, please contact the Governor's Office of Human Trafficking Prevention at "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "mailto:humantrafficking@la.gov"
                                    }
                                  },
                                  [_vm._v("humantrafficking@la.gov")]
                                ),
                                _vm._v(".")
                              ]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "labor-screening__description" },
                              [_c("b", [_vm._v("Pre-Screening Criteria")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "labor-screening__description" },
                              [
                                _vm._v(
                                  "To ensure that the the Louisiana Child and Youth Labor Trafficking Identification Tool is implemented consistently, select the screening criteria that applies to the child/youth."
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "prelimDiv",
                                staticStyle: { paddingLeft: "1.45em" }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      disabled: _vm.isLaborScreeningCreated,
                                      "label-size": "lg",
                                      "label-class": "bold",
                                      label: ""
                                    }
                                  },
                                  _vm._l(
                                    Object.entries(_vm.prelimFields["Main"]),
                                    function(ref) {
                                      var key = ref[0]
                                      var value = ref[1]
                                      return _c(
                                        "div",
                                        { key: key },
                                        [
                                          _c(
                                            "b-form-radio",
                                            {
                                              staticClass: "radioCheckbox",
                                              attrs: {
                                                value: key,
                                                name: "prelimMainSelection"
                                              },
                                              model: {
                                                value:
                                                  _vm.prelimRadioConditionalModel,
                                                callback: function($$v) {
                                                  _vm.prelimRadioConditionalModel = $$v
                                                },
                                                expression:
                                                  "prelimRadioConditionalModel"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(value.desc) +
                                                  "\n                                            "
                                              ),
                                              key === "prelim_selective" &&
                                              _vm.laborScreening[
                                                "prelim_selective"
                                              ] === true
                                                ? _c(
                                                    "div",
                                                    [
                                                      _vm._l(
                                                        Object.entries(
                                                          _vm.prelimFields[
                                                            "Selective"
                                                          ]
                                                        ),
                                                        function(ref) {
                                                          var sKey = ref[0]
                                                          var sValue = ref[1]
                                                          return _c(
                                                            "b-form-checkbox",
                                                            {
                                                              key: sKey,
                                                              class: {
                                                                bold:
                                                                  sValue.boldDesc
                                                              },
                                                              attrs: {
                                                                size: "lg"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .laborScreening[
                                                                    sKey
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.laborScreening,
                                                                    sKey,
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "laborScreening[sKey]"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    sValue.desc
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.prelimSelectiveOptionsError &&
                                                                _vm
                                                                  .laborScreening[
                                                                  key
                                                                ],
                                                              expression:
                                                                "prelimSelectiveOptionsError && laborScreening[key]"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "text-info"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    Selecting a selective screening criteria is required.\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              value.type === "other"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _vm.laborScreening[key]
                                                        ? _c(
                                                            "b-form-textarea",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required",
                                                                  expression:
                                                                    "'required'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "screening__form-input",
                                                              attrs: {
                                                                "data-vv-name":
                                                                  value.textVar,
                                                                "data-vv-as":
                                                                  "Other",
                                                                id:
                                                                  value.textVar,
                                                                name:
                                                                  value.textVar,
                                                                maxlength: 255
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .laborScreening[
                                                                    value
                                                                      .textVar
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.laborScreening,
                                                                    value.textVar,
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "laborScreening[value.textVar]"
                                                              }
                                                            }
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.inputValidationErrors.has(
                                                                  value.textVar
                                                                ) &&
                                                                _vm
                                                                  .laborScreening[
                                                                  key
                                                                ],
                                                              expression:
                                                                "inputValidationErrors.has(value.textVar) && laborScreening[key]"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "text-info"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    " +
                                                              _vm._s(
                                                                _vm.inputValidationErrors.first(
                                                                  value.textVar
                                                                )
                                                              ) +
                                                              "\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isExisting
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "labor-screening__button-wrapper button-container"
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "secondary" },
                                        on: { click: _vm.cancelModal }
                                      },
                                      [_vm._v("Cancel")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "primary" },
                                        on: { click: _vm.completePrelim }
                                      },
                                      [_vm._v("Next")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Screening",
                        disabled: _vm.disabledScreeningTab
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-tabs",
                                {
                                  staticClass:
                                    "labor-screening__tabs nestedTabs",
                                  model: {
                                    value: _vm.screeningTabIndex,
                                    callback: function($$v) {
                                      _vm.screeningTabIndex = $$v
                                    },
                                    expression: "screeningTabIndex"
                                  }
                                },
                                [
                                  _c("b-tab", { attrs: { title: "Ends" } }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "labor-screening__header labor-screening__header--italic"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        The ends of the crime refer to the specific type of victimization that the child or youth is experiencing.\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("i", [
                                        _vm._v(
                                          "Did the child or youth engage in labor or services against their will, or were they forced to work to pay off debt?"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "labor-screening__form" },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              "label-size": "lg",
                                              "label-class": "bold",
                                              label: "Forced Labor",
                                              disabled:
                                                _vm.isLaborScreeningCreated
                                            }
                                          },
                                          [
                                            _vm._l(
                                              Object.entries(
                                                _vm.endsLaborFields[
                                                  "FORCED_LABOR"
                                                ]
                                              ),
                                              function(ref) {
                                                var key = ref[0]
                                                var value = ref[1]
                                                return _c(
                                                  "b-form-checkbox",
                                                  {
                                                    key: key,
                                                    attrs: { size: "lg" },
                                                    model: {
                                                      value:
                                                        _vm.laborScreening[key],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.laborScreening,
                                                          key,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "laborScreening[key]"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(value.desc) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: { size: "lg" },
                                                model: {
                                                  value:
                                                    _vm.laborScreening
                                                      .e_fl_other,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.laborScreening,
                                                      "e_fl_other",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "laborScreening.e_fl_other"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                Other\n                                                "
                                                ),
                                                _vm.laborScreening.e_fl_other
                                                  ? _c("b-form-input", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "labor-screening__form-input",
                                                      attrs: {
                                                        "data-vv-name":
                                                          "e_fl_otherText",
                                                        "data-vv-as": "Other",
                                                        id: "e-fl-otherText",
                                                        type: "text",
                                                        name: "e-fl-otherText",
                                                        size: "lg"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.laborScreening
                                                            .e_fl_otherText,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.laborScreening,
                                                            "e_fl_otherText",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "laborScreening.e_fl_otherText"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.inputValidationErrors.has(
                                                            "e_fl_otherText"
                                                          ) &&
                                                          _vm.laborScreening
                                                            .e_fl_other,
                                                        expression:
                                                          "inputValidationErrors.has('e_fl_otherText') && laborScreening.e_fl_other"
                                                      }
                                                    ],
                                                    staticClass: "text-info"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.inputValidationErrors.first(
                                                            "e_fl_otherText"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              "label-size": "lg",
                                              "label-class": "bold",
                                              label: "Debt Bondage",
                                              disabled:
                                                _vm.isLaborScreeningCreated
                                            }
                                          },
                                          [
                                            _vm._l(
                                              Object.entries(
                                                _vm.endsLaborFields[
                                                  "DEBT_BONDAGE"
                                                ]
                                              ),
                                              function(ref) {
                                                var key = ref[0]
                                                var value = ref[1]
                                                return _c(
                                                  "b-form-checkbox",
                                                  {
                                                    key: key,
                                                    attrs: { size: "lg" },
                                                    model: {
                                                      value:
                                                        _vm.laborScreening[key],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.laborScreening,
                                                          key,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "laborScreening[key]"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(value.desc) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: { size: "lg" },
                                                model: {
                                                  value:
                                                    _vm.laborScreening
                                                      .e_db_other,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.laborScreening,
                                                      "e_db_other",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "laborScreening.e_db_other"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                Other\n                                                "
                                                ),
                                                _vm.laborScreening.e_db_other
                                                  ? _c("b-form-input", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "labor-screening__form-input",
                                                      attrs: {
                                                        "data-vv-name":
                                                          "e_db_otherText",
                                                        "data-vv-as": "Other",
                                                        id: "e-db-otherText",
                                                        type: "text",
                                                        name: "e-db-otherText",
                                                        size: "lg"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.laborScreening
                                                            .e_db_otherText,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.laborScreening,
                                                            "e_db_otherText",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "laborScreening.e_db_otherText"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.inputValidationErrors.has(
                                                            "e_db_otherText"
                                                          ) &&
                                                          _vm.laborScreening
                                                            .e_db_other,
                                                        expression:
                                                          "inputValidationErrors.has('e_db_otherText') && laborScreening.e_db_other"
                                                      }
                                                    ],
                                                    staticClass: "text-info"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.inputValidationErrors.first(
                                                            "e_db_otherText"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("b-tab", { attrs: { title: "Means" } }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "labor-screening__header labor-screening__header--italic"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        The means refers to the methods of force, fraud, and coercion a perpetrator uses to keep the child or youth in a trafficking situation.\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("i", [
                                        _vm._v(
                                          "What did the perpetrator do (or threaten to do) to ensure that the child or youth provided labor or services?"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "labor-screening__form" },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              "label-size": "lg",
                                              "label-class": "bold",
                                              label:
                                                "Coercion (psychological, mental, or emotional control)",
                                              disabled:
                                                _vm.isLaborScreeningCreated
                                            }
                                          },
                                          [
                                            _vm._l(
                                              Object.entries(
                                                _vm.meansLaborFields["COERCION"]
                                              ),
                                              function(ref) {
                                                var key = ref[0]
                                                var value = ref[1]
                                                return _c(
                                                  "b-form-checkbox",
                                                  {
                                                    key: key,
                                                    attrs: { size: "lg" },
                                                    model: {
                                                      value:
                                                        _vm.laborScreening[key],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.laborScreening,
                                                          key,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "laborScreening[key]"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(value.desc) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: { size: "lg" },
                                                model: {
                                                  value:
                                                    _vm.laborScreening
                                                      .m_c_other,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.laborScreening,
                                                      "m_c_other",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "laborScreening.m_c_other"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                Other\n                                                "
                                                ),
                                                _vm.laborScreening.m_c_other
                                                  ? _c("b-form-input", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "labor-screening__form-input",
                                                      attrs: {
                                                        "data-vv-name":
                                                          "m_c_otherText",
                                                        "data-vv-as": "Other",
                                                        id: "m-c-otherText",
                                                        type: "text",
                                                        name: "m-c-otherText",
                                                        size: "lg"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.laborScreening
                                                            .m_c_otherText,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.laborScreening,
                                                            "m_c_otherText",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "laborScreening.m_c_otherText"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.inputValidationErrors.has(
                                                            "m_c_otherText"
                                                          ) &&
                                                          _vm.laborScreening
                                                            .m_c_other,
                                                        expression:
                                                          "inputValidationErrors.has('m_c_otherText') && laborScreening.m_c_other"
                                                      }
                                                    ],
                                                    staticClass: "text-info"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.inputValidationErrors.first(
                                                            "m_c_otherText"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              "label-size": "lg",
                                              "label-class": "bold",
                                              label:
                                                "Fraud (tricked, lied to, or defrauded)",
                                              disabled:
                                                _vm.isLaborScreeningCreated
                                            }
                                          },
                                          [
                                            _vm._l(
                                              Object.entries(
                                                _vm.meansLaborFields["FRAUD"]
                                              ),
                                              function(ref) {
                                                var key = ref[0]
                                                var value = ref[1]
                                                return _c(
                                                  "b-form-checkbox",
                                                  {
                                                    key: key,
                                                    attrs: { size: "lg" },
                                                    model: {
                                                      value:
                                                        _vm.laborScreening[key],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.laborScreening,
                                                          key,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "laborScreening[key]"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(value.desc) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: { size: "lg" },
                                                model: {
                                                  value:
                                                    _vm.laborScreening
                                                      .m_fr_other,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.laborScreening,
                                                      "m_fr_other",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "laborScreening.m_fr_other"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                Other\n                                                "
                                                ),
                                                _vm.laborScreening.m_fr_other
                                                  ? _c("b-form-input", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "labor-screening__form-input",
                                                      attrs: {
                                                        "data-vv-name":
                                                          "m_fr_otherText",
                                                        "data-vv-as": "Other",
                                                        id: "m-fr-otherText",
                                                        type: "text",
                                                        name: "m-fr-otherText",
                                                        size: "lg"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.laborScreening
                                                            .m_fr_otherText,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.laborScreening,
                                                            "m_fr_otherText",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "laborScreening.m_fr_otherText"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.inputValidationErrors.has(
                                                            "m_fr_otherText"
                                                          ) &&
                                                          _vm.laborScreening
                                                            .m_fr_other,
                                                        expression:
                                                          "inputValidationErrors.has('m_fr_otherText') && laborScreening.m_fr_other"
                                                      }
                                                    ],
                                                    staticClass: "text-info"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.inputValidationErrors.first(
                                                            "m_fr_otherText"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              "label-size": "lg",
                                              "label-class": "bold",
                                              label:
                                                "Force (physical control or restraint)",
                                              disabled:
                                                _vm.isLaborScreeningCreated
                                            }
                                          },
                                          [
                                            _vm._l(
                                              Object.entries(
                                                _vm.meansLaborFields["FORCE"]
                                              ),
                                              function(ref) {
                                                var key = ref[0]
                                                var value = ref[1]
                                                return _c(
                                                  "b-form-checkbox",
                                                  {
                                                    key: key,
                                                    attrs: { size: "lg" },
                                                    model: {
                                                      value:
                                                        _vm.laborScreening[key],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.laborScreening,
                                                          key,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "laborScreening[key]"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(value.desc) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: { size: "lg" },
                                                model: {
                                                  value:
                                                    _vm.laborScreening
                                                      .m_fo_other,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.laborScreening,
                                                      "m_fo_other",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "laborScreening.m_fo_other"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                Other\n                                                "
                                                ),
                                                _vm.laborScreening.m_fo_other
                                                  ? _c("b-form-input", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "labor-screening__form-input",
                                                      attrs: {
                                                        "data-vv-name":
                                                          "m_fo_otherText",
                                                        "data-vv-as": "Other",
                                                        id: "m-fo-otherText",
                                                        type: "text",
                                                        name: "m-fo-otherText",
                                                        size: "lg"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.laborScreening
                                                            .m_fo_otherText,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.laborScreening,
                                                            "m_fo_otherText",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "laborScreening.m_fo_otherText"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.inputValidationErrors.has(
                                                            "m_fo_otherText"
                                                          ) &&
                                                          _vm.laborScreening
                                                            .m_fo_other,
                                                        expression:
                                                          "inputValidationErrors.has('m_fo_otherText') && laborScreening.m_fo_other"
                                                      }
                                                    ],
                                                    staticClass: "text-info"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.inputValidationErrors.first(
                                                            "m_fo_otherText"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("b-tab", { attrs: { title: "Process" } }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "labor-screening__header labor-screening__header--italic"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        The 'process' refers to the actions the perpetrator takes to compel the child or youth into a trafficking situation.\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("i", [
                                        _vm._v(
                                          "What were the intentional acts the perpetrator took to get the child or youth in the situation?"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "labor-screening__form" },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              disabled:
                                                _vm.isLaborScreeningCreated
                                            }
                                          },
                                          [
                                            _vm._l(
                                              Object.entries(
                                                _vm.processLaborFields
                                              ),
                                              function(ref) {
                                                var key = ref[0]
                                                var value = ref[1]
                                                return _c(
                                                  "b-form-checkbox",
                                                  {
                                                    key: key,
                                                    attrs: { size: "lg" },
                                                    model: {
                                                      value:
                                                        _vm.laborScreening[key],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.laborScreening,
                                                          key,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "laborScreening[key]"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(value.desc) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: { size: "lg" },
                                                model: {
                                                  value:
                                                    _vm.laborScreening.p_other,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.laborScreening,
                                                      "p_other",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "laborScreening.p_other"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                Other\n                                                "
                                                ),
                                                _vm.laborScreening.p_other
                                                  ? _c("b-form-input", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "labor-screening__form-input",
                                                      attrs: {
                                                        "data-vv-name":
                                                          "p_otherText",
                                                        "data-vv-as": "Other",
                                                        id: "p-otherText",
                                                        type: "text",
                                                        name: "p-otherText",
                                                        size: "lg"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.laborScreening
                                                            .p_otherText,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.laborScreening,
                                                            "p_otherText",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "laborScreening.p_otherText"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.inputValidationErrors.has(
                                                            "p_otherText"
                                                          ) &&
                                                          _vm.laborScreening
                                                            .p_other,
                                                        expression:
                                                          "inputValidationErrors.has('p_otherText') && laborScreening.p_other"
                                                      }
                                                    ],
                                                    staticClass: "text-info"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.inputValidationErrors.first(
                                                            "p_otherText"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    { attrs: { title: "Location" } },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "labor-screening__header"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        Select Your Labor Screening Location and Program:\n                                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "labor-screening__description"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        Select the location and program where this Labor Screening occurred.\n                                        If location and program are not selected, it will default to the primary location and program of the organization.\n                                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            "label-size": "lg",
                                            label: "Location",
                                            "label-for": "location",
                                            horizontal: false
                                          }
                                        },
                                        [
                                          !_vm.isLaborScreeningCreated
                                            ? _c(
                                                "b-form-select",
                                                {
                                                  attrs: {
                                                    id: "location",
                                                    options:
                                                      _vm.locationOptions,
                                                    placeholder:
                                                      "Select a Location"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.laborScreening
                                                        .location,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.laborScreening,
                                                        "location",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "laborScreening.location"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.laborScreening
                                                          .location
                                                      ) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "labor-screening__description"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(_vm.locationName) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            "label-size": "lg",
                                            label: "Program",
                                            "label-for": "program",
                                            horizontal: false
                                          }
                                        },
                                        [
                                          !_vm.isLaborScreeningCreated
                                            ? _c(
                                                "b-form-select",
                                                {
                                                  attrs: {
                                                    id: "program",
                                                    options: _vm.programOptions,
                                                    placeholder:
                                                      "Select a Program"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.laborScreening
                                                        .program,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.laborScreening,
                                                        "program",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "laborScreening.program"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.laborScreening
                                                          .program
                                                      ) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "labor-screening__description"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(_vm.programName) +
                                                      "\n                                        "
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.isExisting
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "labor-screening__button-wrapper button-container padding24"
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "secondary" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.cancelModal.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _vm._v(" "),
                                          _vm.showPreviousBtn
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "outline-primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.prevScreeningTab.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Previous")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showNextBtn
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.nextScreeningTab.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Next")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showSubmitBtn
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.submit.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Submit")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Conclusion",
                        disabled: _vm.disabledConclusionTab
                      }
                    },
                    [
                      _c("div", { staticClass: "padding24" }, [
                        _c("h5", { staticClass: "labor-screening__header" }, [
                          _vm._v(
                            "\n                            Summary:\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "labor-screening__table" },
                          [
                            _c(
                              "b-row",
                              { staticClass: "labor-screening__row" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "labor-screening__col",
                                    attrs: { cols: "9" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                                        ENDS\n                                    "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "labor-screening__col",
                                    attrs: { cols: "3" }
                                  },
                                  [
                                    _c("b-checkbox", {
                                      attrs: {
                                        checked: _vm.isEndsChecked,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "labor-screening__row" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "labor-screening__col",
                                    attrs: { cols: "9" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                                        MEANS\n                                    "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "labor-screening__col",
                                    attrs: { cols: "3" }
                                  },
                                  [
                                    _c("b-checkbox", {
                                      attrs: {
                                        checked: _vm.isMeansChecked,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "labor-screening__row" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "labor-screening__col",
                                    attrs: { cols: "9" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                                        PROCESS\n                                    "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "labor-screening__col",
                                    attrs: { cols: "3" }
                                  },
                                  [
                                    _c("b-checkbox", {
                                      attrs: {
                                        checked: _vm.isProcessChecked,
                                        disabled: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "labor-screening__conclusion labor-screening__description"
                          },
                          [
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "labor-screening__description--bold"
                              },
                              [
                                _vm._v(
                                  "\n                                Conclusion:\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { class: _vm.laborScreeningConclusionClasses },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.LABOR_CONCLUSION_LABEL_MAP[
                                        this.laborScreening.conclusion
                                      ]
                                    ) +
                                    "\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.laborScreening.conclusion ===
                            _vm.LABOR_SCREENING_CONCLUSION.NOT_ENOUGH_INFO
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "If there is one checkbox in one of the categories or no boxes checked, there is not enough information to determine the child or youth is a potential victim of labor trafficking."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("i", [
                                      _vm._v(
                                        "Action to be taken: Continue to monitor the child or youth. Follow mandatory reporting guidelines if you suspect abuse or neglect to a child under 18 years of age by a parent or caretaker. If you suspect a crime has occurred or the child or youth is in immediate danger, report to law enforcement."
                                      )
                                    ])
                                  ])
                                ])
                              : _vm.laborScreening.conclusion ===
                                _vm.LABOR_SCREENING_CONCLUSION.LEVEL1
                              ? _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "If there is at least one checkbox in at least two of the categories, there is concern that the child or youth could potentially be a victim of labor trafficking."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("i", [
                                      _vm._v(
                                        "Action to be taken: Immediately report to law enforcement if you suspect a crime has occurred or the child or youth is in immediate danger. If you suspect child abuse or neglect to a child under 18 years of age by a parent or caretaker, call the "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://www.dcfs.la.gov/",
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v("DCFS")]
                                      ),
                                      _vm._v(
                                        " Child Abuse/Neglect Hotline at 855-452-5437. Refer to services for additional assessment by contacting the National Human Trafficking Hotline at 888-373-7888 or by referring to "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "https://humantrafficking.la.gov/resources/",
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v("a local service provider")]
                                      ),
                                      _vm._v(
                                        " with expertise in human trafficking."
                                      )
                                    ])
                                  ])
                                ])
                              : _vm.laborScreening.conclusion ===
                                _vm.LABOR_SCREENING_CONCLUSION.LEVEL2
                              ? _c(
                                  "div",
                                  [
                                    _c("p", [
                                      _vm._v(
                                        'If there is at least one checkbox in all three categories (Ends, Means, Process), the child or youth meets the state definition of human trafficking and is considered "indicated" for labor trafficking.'
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("i", [
                                        _vm._v(
                                          "Action to be taken: Immediately report to law enforcement. If you suspect child abuse or neglect to a child under 18 years of age by a parent or caretaker, call the "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "https://www.dcfs.la.gov/",
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v("DCFS")]
                                        ),
                                        _vm._v(
                                          " Child Abuse/Neglect Hotline at 855-452-5437. Refer the child to Care Coordination by emailing "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "mailto:carecoordination@lacacs.org"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "carecoordination@lacacs.org"
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          " and attach a copy of the screening tool. (Click Print below.)"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("i", [
                                        _vm._v(
                                          "If the child is a non-U.S. citizen or non-lawful permanent resident, report to "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "https://www.acf.hhs.gov/otip",
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "HHS Office of Trafficking in Persons (OTIP)"
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          " by submitting a Request for Assistance (RFA) through "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "https://atims.acf.hhs.gov/eaasidentityserver/Identity/Account/Login/LoginSelection/",
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v("Shepherd")]
                                        ),
                                        _vm._v(
                                          ". (Contact the OTIP Child Protection Specialists by phone at 202-205-4582 or email at "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "mailto:ChildTrafficking@acf.hhs.gov"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "ChildTrafficking@acf.hhs.gov"
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          ".) Also consider referring the child/youth to an attorney to help assess qualifications for legal relief as a potential trafficking victim."
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("i", [
                                        _vm._v(
                                          "If the individual is a youth, or aged 18 years or older, provide the individual with the National Human Trafficking Hotline at 888-373-7888 and offer to make a referral to "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "https://humantrafficking.la.gov/resources/",
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v("a local service provider")]
                                        ),
                                        _vm._v(
                                          " with expertise in human trafficking. If the individual is an adult with a disability, report also to Adult Protective Services at 800-898-4910."
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("i", [
                                        _vm._v(
                                          "Update the Victim Status for the child or youth and complete the requested information."
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "primary" },
                                        on: { click: _vm.goToVictimStatus }
                                      },
                                      [_vm._v("Update Victim Status")]
                                    ),
                                    _vm._v(" "),
                                    _c("p"),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("i", [
                                        _vm._v(
                                          "Please note: This tool does not include a result for a confirmed victim of human trafficking. If you receive certification of the child or youth being a confirmed victim of trafficking after completing the screening, you must update their victim status to “confirmed.” A trafficking event is considered “confirmed” when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in La. RS 14:46.2, La. RS 14:46.3, or the federal Trafficking Victims Protection Act (TVPA). While the tool does provide indicators to meet the state legal definition of trafficking, the tool is insufficient alone to weigh the totality of evidence or to replace the assessment of qualified professionals (such as, law enforcement, U.S. Attorney, District Attorney, HHS, victim advocate, Care Coordinator, or other qualified professional.)"
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "labor-screening__description" },
                          [
                            _c("b", [
                              _vm._v(
                                "\n                                Location:\n                            "
                              )
                            ]),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.locationName) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "labor-screening__description" },
                          [
                            _c("b", [
                              _vm._v(
                                "\n                                Program:\n                            "
                              )
                            ]),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.programName) +
                                "\n                        "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "padding24" },
                [
                  _vm.isLaborScreeningCreated
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mb-2 mt-2",
                          attrs: {
                            type: "button",
                            variant: "primary",
                            size: "md"
                          },
                          on: { click: _vm.print }
                        },
                        [
                          _c("span", { staticClass: "button-text" }, [
                            _vm._v(
                              "\n                        Print\n                    "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLaborScreeningCreated
            ? _c(
                "b-col",
                { attrs: { sm: "3" } },
                [
                  _c("SharePersonList", {
                    attrs: {
                      personId: _vm.laborScreening.person._id,
                      personOrganizationOwner:
                        _vm.laborScreening.person.organizationOwner
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { attrs: { "no-body": "", title: _vm.laborScreening.id } },
                    [
                      _c("b-card-header", [_c("b", [_vm._v("Meta")])]),
                      _vm._v(" "),
                      _c("b-card-body", [
                        _c("p", { staticClass: "card-text" }, [
                          _c(
                            "small",
                            { staticClass: "text-muted text-uppercase bold" },
                            [_vm._v("Labor Screening ID: ")]
                          ),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v(" " + _vm._s(_vm.laborScreening.id) + " ")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-text" }, [
                          _c(
                            "small",
                            { staticClass: "text-muted text-uppercase bold" },
                            [_vm._v("Person ID")]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "small",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to:
                                      "/person/" + _vm.laborScreening.person.id
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.laborScreening.person.id) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-list-group",
                        { attrs: { flush: "" } },
                        [
                          _c(
                            "b-list-group-item",
                            { staticClass: "small text-muted" },
                            [
                              _c("b", [_vm._v("Created At: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getCreatedAt()) +
                                  "\n                        "
                              ),
                              _vm._.isObject(_vm.laborScreening.createdBy)
                                ? _c("div", [
                                    _c("b", [_vm._v(" by: ")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._.get(
                                            _vm.laborScreening,
                                            "createdBy.emailAddress",
                                            ""
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("b", [_vm._v("Last Updated: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getLastUpdateDate()) +
                                  "\n                        "
                              ),
                              _vm._.isObject(_vm.laborScreening.updatedBy)
                                ? _c("div", [
                                    _c("b", [_vm._v(" by: ")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._.get(
                                            _vm.laborScreening,
                                            "updatedBy.emailAddress",
                                            ""
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            { staticClass: "small text-muted" },
                            [
                              _c("p", { staticClass: "card-text" }, [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "text-muted text-uppercase bold"
                                  },
                                  [_vm._v("Current Record Owner")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _c("b", [_vm._v(" by: ")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.laborScreening,
                                          "organizationOwner.title"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        _vm._b(
          {
            ref: "noSelectionModal",
            attrs: { "ok-only": "" },
            scopedSlots: _vm._u([
              {
                key: "modal-header-close",
                fn: function() {
                  return [_c("h4", [_vm._v("X")])]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.showNoSelectionModal,
              callback: function($$v) {
                _vm.showNoSelectionModal = $$v
              },
              expression: "showNoSelectionModal"
            }
          },
          "b-modal",
          {
            centered: true,
            title: "Labor Trafficking Screening - " + this.noSelectionSection,
            size: "lg",
            "ok-title": "Okay",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            class: "tos-modal",
            "hide-header-close": true,
            "no-close-on-backdrop": true
          },
          false
        ),
        [
          _vm._v(" "),
          this.noSelectionSection === "Introduction"
            ? _c("p", [
                _vm._v(
                  "Please select the pre-screening criteria that applies to the child/youth prior to continuing with the screening."
                )
              ])
            : _c("p", [
                _vm._v(
                  "If none of these circumstances apply for the youth, please go back and select the I am not aware of these circumstances applying to the youth/child option."
                )
              ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        _vm._b(
          {
            ref: "cancelModal",
            on: { cancel: _vm.goBackToPersonRecord },
            scopedSlots: _vm._u([
              {
                key: "modal-header-close",
                fn: function() {
                  return [_c("h4", [_vm._v("X")])]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.showCancelModal,
              callback: function($$v) {
                _vm.showCancelModal = $$v
              },
              expression: "showCancelModal"
            }
          },
          "b-modal",
          _vm.cancelModalProps,
          false
        ),
        [
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.cancelModalDescription) +
                "\n        "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e64c9fe4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e64c9fe4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/LaborScreening.vue
// module id = 1760
// module chunks = 0